import { render, staticRenderFns } from "./wenHeader.vue?vue&type=template&id=79abbbf3&scoped=true&"
import script from "./wenHeader.vue?vue&type=script&lang=js&"
export * from "./wenHeader.vue?vue&type=script&lang=js&"
import style0 from "./wenHeader.vue?vue&type=style&index=0&id=79abbbf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79abbbf3",
  null
  
)

export default component.exports